export default "__VITE_ASSET__C5HAL8a6__"